import { useCallback, useEffect, useState } from 'react';
import { getFavorites, updateFavorite } from '../utils/api';

export function useFavorites(isAuthenticated, userId) {
  const [favoriteSlugs, setFavoriteSlugs] = useState(new Set());
  const [favoriteItems, setFavoriteItems] = useState([]);

  // 初始加载收藏列表
  useEffect(() => {
    if (!isAuthenticated || !userId) return;

    (async () => {
      try {
        const res = await getFavorites(userId);
        const items = Array.isArray(res.data) ? res.data : [];
        setFavoriteItems(items);
        setFavoriteSlugs(new Set(items.map((x) => x.slug)));
      } catch (e) {
        console.error('[收藏] 加载失败：', e);
      }
    })();
  }, [isAuthenticated, userId]);

  const toggleFavorite = useCallback(async (slug, pushToast) => {
    if (!isAuthenticated || !userId) {
      return false;
    }

    const isFavorited = favoriteSlugs.has(slug);
    const action = isFavorited ? 'delete' : 'add';

    try {
      await updateFavorite(userId, slug, action);

      if (action === 'add') {
        setFavoriteSlugs((prev) => new Set([...prev, slug]));
        pushToast('已添加到收藏', 'success');
      } else {
        setFavoriteSlugs((prev) => {
          const next = new Set(prev);
          next.delete(slug);
          return next;
        });
        pushToast('已取消收藏', 'info');
      }
      return true;
    } catch (e) {
      console.error('[收藏] 操作失败：', e);
      pushToast('操作失败，请稍后重试', 'info');
      return false;
    }
  }, [isAuthenticated, userId, favoriteSlugs]);

  const removeFavorite = useCallback(async (slug) => {
    if (!isAuthenticated || !userId) return;

    try {
      await updateFavorite(userId, slug, 'delete');
      setFavoriteSlugs((prev) => {
        const next = new Set(prev);
        next.delete(slug);
        return next;
      });
      setFavoriteItems((prev) => prev.filter((x) => x.slug !== slug));
    } catch (e) {
      console.error('[收藏] 删除失败：', e);
    }
  }, [isAuthenticated, userId]);

  const refreshFavorites = useCallback(async () => {
    if (!isAuthenticated || !userId) return;

    try {
      const res = await getFavorites(userId);
      const items = Array.isArray(res.data) ? res.data : [];
      setFavoriteItems(items);
      setFavoriteSlugs(new Set(items.map((x) => x.slug)));
    } catch (e) {
      console.error('[收藏] 刷新失败：', e);
    }
  }, [isAuthenticated, userId]);

  return {
    favoriteSlugs,
    favoriteItems,
    toggleFavorite,
    removeFavorite,
    refreshFavorites,
    setFavoriteItems,
    setFavoriteSlugs
  };
}
